import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    inject,
} from '@angular/core';
import {
    DialogButtonComponent,
    DialogButtonsComponent,
    DialogComponent,
    DialogDescriptionComponent,
} from '@interacta-shared/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import {
    ConfirmDialogService,
    ConfirmDialogState,
} from './confirm-dialog.service';

@Component({
    selector: 'interacta-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    imports: [
        DialogButtonComponent,
        DialogButtonsComponent,
        DialogComponent,
        DialogDescriptionComponent,
        TranslatePipe,
        AsyncPipe,
        NgTemplateOutlet,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements OnInit {
    private confirmDialogService = inject(ConfirmDialogService);

    state$!: Observable<ConfirmDialogState>;

    ngOnInit(): void {
        this.state$ = this.confirmDialogService.getState();
    }

    close(confirm: boolean): void {
        this.confirmDialogService.close(confirm);
    }

    dismiss(): void {
        this.confirmDialogService.dismiss();
    }
}
